// extracted by mini-css-extract-plugin
export var box = "_5o-0";
export var check = "_5o-1";
export var checkboxButton = "_5o-6";
export var checkboxGroup = "_5o-5";
export var disabled = "_5o-7";
export var ghost = "_5o-9";
export var input = "_5o-2";
export var label = "_5o-4";
export var normal = "_5o-8";
export var uncheck = "_5o-3";